/**
 * Перевірює, чи активний елемент каруселі
 * @param {Object} item - елемент каруселі
 * @returns {boolean} - true якщо елемент активний
 */
export const isCarouselItemActive = (item) => {
  if (!item || !item.slideType) {
    return false;
  }

  switch (item.slideType) {
    case 'blog':
      return item.active === true;
    case 'product':
      return item.enabled === true;
    case 'banner':
      return item.active === true;
    default:
      return false;
  }
};

/**
 * Фільтрує масив елементів каруселі, залишаючи тільки активні
 * @param {Array} items - масив елементів каруселі
 * @returns {Array} - масив активних елементів
 */
export const filterActiveCarouselItems = (items) => {
  if (!Array.isArray(items)) {
    return [];
  }
  
  return items.filter(isCarouselItemActive);
};

/**
 * Отримує текстовий статус елемента каруселі
 * @param {Object} item - елемент каруселі
 * @returns {string} - статус у вигляді рядка
 */
export const getCarouselItemStatus = (item) => {
  return isCarouselItemActive(item) ? 'Активний' : 'Неактивний';
};

/**
 * Отримує CSS клас для елемента каруселі
 * @param {Object} item - елемент каруселі
 * @returns {string} - CSS клас
 */
export const getCarouselItemClass = (item) => {
  return isCarouselItemActive(item) ? 'active' : 'inactive';
};

/**
 * Валідує елемент каруселі перед відображенням
 * @param {Object} item - елемент каруселі
 * @returns {Object} - об'єкт з результатами валідації
 */
export const validateCarouselItem = (item) => {
  const validation = {
    isValid: false,
    isActive: false,
    hasImage: false,
    hasTitle: false,
    warnings: [],
    errors: []
  };

  if (!item) {
    validation.errors.push('Елемент не існує');
    return validation;
  }

  // Перевірка активності
  validation.isActive = isCarouselItemActive(item);
  if (!validation.isActive) {
    validation.warnings.push('Елемент неактивний');
  }

  // Перевірка зображення
  validation.hasImage = !!(item.imageUrl || item.imageFirst);
  if (!validation.hasImage) {
    validation.errors.push('Відсутнє зображення');
  }

  // Перевірка заголовку
  validation.hasTitle = !!(item.title || item.name);
  if (!validation.hasTitle) {
    validation.warnings.push('Відсутній заголовок');
  }

  // Загальна валідація
  validation.isValid = validation.hasImage && validation.errors.length === 0;

  return validation;
};

/**
 * Сортує елементи каруселі за порядком та активністю
 * @param {Array} items - масив елементів каруселі
 * @returns {Array} - відсортований масив
 */
export const sortCarouselItems = (items) => {
  if (!Array.isArray(items)) {
    return [];
  }

  return [...items].sort((a, b) => {
    // Спочатку активні елементи
    const aActive = isCarouselItemActive(a);
    const bActive = isCarouselItemActive(b);
    
    if (aActive && !bActive) return -1;
    if (!aActive && bActive) return 1;
    
    // Потім за порядком
    return (a.order || 0) - (b.order || 0);
  });
};

export default {
  isCarouselItemActive,
  filterActiveCarouselItems,
  getCarouselItemStatus,
  getCarouselItemClass,
  validateCarouselItem,
  sortCarouselItems
};